angular.module("ainapp")
    .controller("PendingPDCController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
        function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Pending PDCs";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }



            $scope.Init = function () {

                $scope.Filter = {
                    PDCType: "Pending",
                    ChequeNo: "",
                    Type: "",
                    DateFrom: new Date(),
                    DateTo: new Date(),
                    CustomerIds: [],
                }

                $scope.Load = false;

            }
            $scope.Init();

            $scope.FilterData = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.ClearData = function () {
                $scope.Init();
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.customerSelectDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter != undefined) {
                            if (o.data.filter.filters.length > 0) {
                                MainService.AccountsInPDCAutoComplete(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success({
                                        Data: []
                                    });
                                    toastr.error("Network Error");
                                });
                            } else {
                                o.success({
                                    Data: []
                                });
                            }
                        } else {
                            o.success({
                                Data: []
                            });
                        }

                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.selectCustomerOptions = {
                placeholder: "Select Accounts...",
                dataTextField: "Name",
                dataValueField: "Id",
                valuePrimitive: true,
                autoBind: true,
                dataSource: $scope.customerSelectDataSource
            };



            $scope.BankAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        MainService.GetBankAccounts(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error($scope.NetworkErrorLan);
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.bankAcountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedData.ReconcileBankAccountId = data.Id;
                    $scope.SelectedData.ReconcileBankAccount = {};
                    $scope.SelectedData.ReconcileBankAccount.Name = data.Name;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.BankAutocompleteDataSource
            };

            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {

                        o.data.FromMonth = $scope.Filter.DateFrom.getMonth() + 1;
                        o.data.FromDay = $scope.Filter.DateFrom.getDate();
                        o.data.FromYear = $scope.Filter.DateFrom.getFullYear();

                        o.data.ToMonth = $scope.Filter.DateTo.getMonth() + 1;
                        o.data.ToDay = $scope.Filter.DateTo.getDate();
                        o.data.ToYear = $scope.Filter.DateTo.getFullYear();

                        o.data.DateFrom = $scope.Filter.DateFrom;
                        o.data.DateTo = $scope.Filter.DateTo;
                        o.data.PDCType = $scope.Filter.PDCType;
                        o.data.ChequeNo = $scope.Filter.ChequeNo;
                        o.data.Type = $scope.Filter.Type;
                        o.data.CustomerIds = $scope.Filter.CustomerIds;

                        MainService.PDCsInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })
                    },

                },
                change: function (data) { },
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Id: {
                                type: "number",
                                editable: false,
                            },
                            Amount: {
                                type: "number",
                                editable: false,
                            },
                            PDCNo: {
                                type: "string",
                                editable: false,
                            },
                            VoucherNo: {
                                type: "string",
                                editable: false,
                            },
                            Type: {
                                type: "string",
                                editable: false,
                            },
                            Status: {
                                type: "string",
                                editable: false,
                            },
                            CustomerAccountName: {
                                type: "string",
                                editable: false,
                            },
                            BankAccountName: {
                                type: "string",
                                editable: false,
                            },
                            PDCAccountName: {
                                type: "string",
                                editable: false,
                            },
                            ChequeNo: {
                                type: "string",
                                editable: false,
                            },
                            ChequeName: {
                                type: "string",
                                editable: false,
                            },
                            ChequeDate: {
                                type: "date",
                                editable: false,
                            },
                            Date: {
                                type: "date",
                                editable: false,
                            },

                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
                aggregate: [
                    {
                        field: "Amount",
                        aggregate: "sum"
                    }
                ],
            });

            $scope.KendoGridOptions = {
                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 700,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },



                columns: [
                    {
                        field: "PDCNo",
                        title: "PDC No",
                        width: '120px'
                    },
                    {
                        field: "VoucherNo",
                        title: "Voucher No",
                        width: '120px'
                    },
                    {
                        field: "Type",
                        title: "Type",
                        width: '220px'
                    },
                    {
                        field: "ChequeNo",
                        title: "Cheque No",
                        width: '220px'
                    },
                    {
                        field: "ChequeName",
                        title: "Cheque Name",
                        width: '220px'
                    },
                    {
                        field: "Date",
                        title: "Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        width: '120px'
                    },
                    {
                        field: "ChequeDate",
                        title: "Cheque Date",
                        template: "#= kendo.toString(kendo.parseDate(ChequeDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        width: '120px'
                    },
                    {
                        field: "Amount",
                        title: "Amount",
                        template: "<div style='text-align: right'>#=kendo.toString(Amount, 'n')#</div>",
                        width: '120px',
                        aggregates: ["sum"],
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                    },
                    {
                        field: "CustomerAccountName",
                        title: "Account",
                        width: '220px'
                    },
                    {
                        field: "BankAccountName",
                        title: "Bank Account ",
                        width: '220px'
                    },
                    {
                        field: "PDCAccountName",
                        title: "PDC Account",
                        width: '220px'
                    },
                    {
                        field: "Status",
                        title: "Status",
                        width: '120px'
                    },
                    {
                        field: "Photo",
                        title: "Photo",
                        template:`<img ng-if="dataItem.Photo != null && dataItem.Photo != ''" src="{{basePath}}{{dataItem.Photo}}" width="100" height="40" />`,
                        width: '120px'
                    },
                    {
                        title: "Options",
                        template: `
                                <button class="btn-default btn-sm" ng-click="ClearCheque(dataItem)">
                                    Clear
                                </button>
                                <button class="btn-default btn-sm" ng-click="bounceCheque(dataItem)">
                                    Bounce
                                </button>
                                <button class="btn-default btn-sm" ng-click="cancelCheque(dataItem)">
                                    Cancel
                                </button>
                                 <button class="btn-default btn-sm" ng-click="replaceCheque(dataItem)">
                                    Replace
                                </button>
                                 <button class="btn-default btn-sm" ng-click="replaceCheque2(dataItem)">
                                    Partial Replace
                                </button>
                            `,
                        width: "320px"
                    }
                ],
            };


            $scope.SelectedData = {};
            $scope.ReturnCheque = function (data) {
                $scope.SelectedData = data;
                $scope.SelectedData.ReconcileDate = new Date(data.ReconcileDate);
                $scope.SelectedData.Status = "Return";
                $("#myModal2").modal("show");
            }

            $scope.ClearCheque = function (data) {
                $scope.SelectedData = data;
                $scope.SelectedData.ReconcileDate = new Date(data.ChequeDate);
                $scope.SelectedData.Status = "Clear";
                $("#modalClear").modal("show");
            }

            $scope.clearWithConfirm = function () {

                $scope.SelectedData.DateMonth = $scope.SelectedData.ReconcileDate.getMonth() + 1;
                $scope.SelectedData.DateDay = $scope.SelectedData.ReconcileDate.getDate();
                $scope.SelectedData.DateYear = $scope.SelectedData.ReconcileDate.getFullYear();

                $scope.Load = true;
                MainService.MakeChequeClear($scope.SelectedData).then(function (response) {
                    if (response.data == 1) {
                        $('#modalClear').modal('hide');
                        toastr.success("Success");
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedData = {};
                    } else if (response.data == 2) {
                        toastr.warning("Processed Already Please Try again");
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedData = {};
                    } else {
                        toastr.warning("Error");
                    }
                    $scope.Load = false;
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.Load = false;
                });

            }


            $scope.bounceCheque = function (data) {
                $scope.SelectedDataBounce = data;
                $scope.SelectedDataBounce.ReconcileDate = new Date(data.ChequeDate);
                $scope.SelectedDataBounce.Status = "Bounce";
                $("#modalBounce").modal("show");
            }

            $scope.bounceWithConfirm = function () {

                $scope.SelectedDataBounce.DateMonth = $scope.SelectedDataBounce.ReconcileDate.getMonth() + 1;
                $scope.SelectedDataBounce.DateDay = $scope.SelectedDataBounce.ReconcileDate.getDate();
                $scope.SelectedDataBounce.DateYear = $scope.SelectedDataBounce.ReconcileDate.getFullYear();

                $scope.Load = true;
                MainService.MakeChequeBounce($scope.SelectedDataBounce).then(function (response) {
                    if (response.data == 1) {
                        $('#modalBounce').modal('hide');
                        toastr.success("Success");
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataBounce = {};
                    } else if (response.data == 2) {
                        toastr.warning("Processed Already Please Try again");
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataBounce = {};
                    } else {
                        toastr.warning("Error");
                    }
                    $scope.Load = false;
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.Load = false;
                });

            }

            $scope.cancelCheque = function (data) {
                $scope.SelectedDataCancel = data;
                $scope.SelectedDataCancel.ReconcileDate = new Date(data.ChequeDate);
                $scope.SelectedDataCancel.Status = "Cancelled";
                $("#modalCancel").modal("show");
            }

            $scope.cancelWithConfirm = function () {

                $scope.SelectedDataCancel.DateMonth = $scope.SelectedDataCancel.ReconcileDate.getMonth() + 1;
                $scope.SelectedDataCancel.DateDay = $scope.SelectedDataCancel.ReconcileDate.getDate();
                $scope.SelectedDataCancel.DateYear = $scope.SelectedDataCancel.ReconcileDate.getFullYear();

                $scope.Load = true;
                MainService.MakeChequeCancel($scope.SelectedDataCancel).then(function (response) {
                    if (response.data == 1) {
                        $('#modalCancel').modal('hide');
                        toastr.success("Success");
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataCancel = {};
                    } else if (response.data == 2) {
                        toastr.warning("Processed Already Please Try again");
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataCancel = {};
                    } else {
                        toastr.warning("Error");
                    }
                    $scope.Load = false;
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.Load = false;
                });

            }

            $scope.AccountAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            };
                            o.data.filter.filters.push(temp);
                        }
                        o.data.LoadType = "Head";
                        o.data.VoucherName = "Credit Note SR";
                        MainService.accountInAutoComplete(o.data).then(
                            function (response) {
                                o.success(response.data);
                            },
                            function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("NetworkError");
                            }
                        );
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 5
            };

            $scope.RelectAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.RepalceData.ReflectAccount = {};
                    $scope.RepalceData.ReflectAccount.Name = data.Name;
                    $scope.RepalceData.ReflectAccountId = data.Id;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.replaceCheque = function (data) {
                $scope.SelectedDataReplace = data;

                $scope.RepalceData = {
                    Type: "",
                    chequeNo: "",
                    ChequeDate: new Date(data.ChequeDate),
                    Remarks: "",
                    Date: new Date(data.ChequeDate),
                    PDCId: data.Id,
                    ReflectAccount: {},
                    ReflectAccountId: "",
                }

                $("#modalReplace").modal("show");
            }


            $scope.ReplaceWithConfirm = function () {

                $scope.RepalceData.DateMonth = $scope.RepalceData.ChequeDate.getMonth() + 1;
                $scope.RepalceData.DateDay = $scope.RepalceData.ChequeDate.getDate();
                $scope.RepalceData.DateYear = $scope.RepalceData.ChequeDate.getFullYear();

                $scope.Load = true;
                MainService.MakeChequeReplace($scope.RepalceData).then(function (response) {
                    if (response.data == 1) {
                        $('#modalReplace').modal('hide');
                        toastr.success("Success");
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataReplace = {};
                    } else if (response.data == 2) {
                        toastr.warning("Processed Already Please Try again");
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataReplace = {};
                    } else {
                        toastr.warning("Error");
                    }
                    $scope.Load = false;
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.Load = false;
                });

            }


            $scope.RelectAccountAutocompleteOptions2 = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.RepalceData2.ReflectAccount = {};
                    $scope.RepalceData2.ReflectAccount.Name = data.Name;
                    $scope.RepalceData2.ReflectAccountId = data.Id;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.replaceCheque2 = function (data) {
                $scope.SelectedDataReplace2 = data;

                $scope.RepalceData2 = {
                    Type: "",
                    chequeNo: "",
                    ChequeDate: new Date(data.ChequeDate),
                    Remarks: "",
                    Date: new Date(data.ChequeDate),
                    PDCId: data.Id,
                    ReflectAccount: {},
                    ReflectAccountId: "",
                    PartialAmount: 0,
                }

                $("#modalReplace2").modal("show");
            }

            
            $scope.ReplaceWithConfirm2 = function () {

                $scope.RepalceData2.DateMonth = $scope.RepalceData2.ChequeDate.getMonth() + 1;
                $scope.RepalceData2.DateDay = $scope.RepalceData2.ChequeDate.getDate();
                $scope.RepalceData2.DateYear = $scope.RepalceData2.ChequeDate.getFullYear();

                $scope.Load = true;
                MainService.MakeChequePartialReplace($scope.RepalceData2).then(function (response) {
                    if (response.data == 1) {
                        $('#modalReplace2').modal('hide');
                        toastr.success("Success");
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataReplace2 = {};
                    } else if (response.data == 2) {
                        toastr.warning("Processed Already Please Try again");
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataReplace2 = {};
                    } else {
                        toastr.warning("Error");
                    }
                    $scope.Load = false;
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.Load = false;
                });

            }

        }])
